var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],attrs:{"type":"error","loading":_vm.loading,"label":"Sync All Counts","icon":"sync"},on:{"onclick":_vm.massSync}})
}
var staticRenderFns = []

export { render, staticRenderFns }